const HeaderTop = () => {
    return null;
};

export default HeaderTop;
